export default __webpack_public_path__ + "static/media/pizza.e858bf3e.jpg";